<template lang="pug">
ds-panel(space="3xl"): ds-panel-element(
  offset="full"
)
  div(slot="top-right")
    control-button.close-modal(
      styling="ghost"
      :disabled="submitting"
      @click.prevent="cancel"
      size="xs"
    ): icon(name="close", size="md")

  ds-panel: ds-panel-element(
    offset="vertical"
  )
    ds-caption(
      size="2"
      variant="strong"
    ) {{ resolvedTitle }}

  container(
    fit="lg"
    space="none"
    align="left"
  )
    div
      | {{ resolvedDescription }}
    
  //- при выборочном unlink даём выбрать,
  //- какую именно связь Client/Lead удалить.
  ds-panel-element(
    v-if="ownerOptions.length"
    offset="top"
  )
    f-select(
      name="owner"
      :data="form"
      :super-label="_('Кого отвязать')"
      label="_telegramOwnerTitle"
      track-by="_telegramOwnerKey"
      :allow-empty="false"
      :preselect-first="true"
      :options="ownerOptions"
    )

  ds-panel-element(offset="top")
    form-line
      form-cell(cols="narrow")
        control-button(
          styling="primary"
          :disabled="submitting"
          @click="confirm"
        ) {{ resolvedConfirmTitle }}

      form-cell(cols="narrow")
        control-button(
          styling="secondary"
          :disabled="submitting"
          @click="cancel"
        ) {{ _('Отмена') }}
</template>

<script>
export default {
  name: 'TelegramChatUnlinkConfirmModal',

  props: {
    promise: {
      type: Function,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    confirmTitle: {
      type: String,
      default: '',
    },
    ownerOptions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      submitting: false,
      form: {
        owner: null,
      },
    }
  },

  computed: {
    resolvedTitle() {
      return this.title || this._('Отвязать Телеграм чат?')
    },

    resolvedDescription() {
      return this.description || this._(
        'Выбранный клиент или лид будут отвязаны от текущего чата'
      )
    },

    resolvedConfirmTitle() {
      return this.confirmTitle || this._('Отвязать')
    },
  },

  mounted() {
    if (this.ownerOptions.length) {
      this.form.owner = this.ownerOptions[0]
    }
  },

  methods: {
    async confirm() {
      if (
        this.ownerOptions.length
        && !this.form.owner
      ) {
        return
      }

      this.submitting = true

      try {
        await this.promise(this.form.owner)
        this.$emit('close')
      } finally {
        this.submitting = false
      }
    },

    cancel() {
      if (this.submitting) {
        return
      }

      this.$emit('close')
    },
  },
}
</script>